import TextField from '@Fields/TextField';
import SelectField from '@Fields/SelectField';
import AutoCompleteField from '@Fields/AutoCompleteField';
import RadioField from '@Fields/RadioField';

class PriceInfoLivestockForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = PriceInfoLivestockForm.modelToState(props);
        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.validatorLivestockPriceInfo = this.validatorLivestockPriceInfo.bind(this);

        //updates the parent's validator to use this method
        var parentState = this.props.parentState;
        parentState.validatorLivestockPriceInfo = this.validatorLivestockPriceInfo;
        this.props.handleFormUpdate(parentState);
    }

    static modelToState(props) {

        return {
            HeadCount: props.model.HeadCount,
            AvgWeight: 0,//spec
            TotalWeight: 0,//spec
            EstimatedWeightVariance: "Even",//spec make these dynamic
            SpecsViewModel: props.SpecsViewModel,
            bHasGeneralSpecs: props.SpecsViewModel.IndexGeneralNotShownInSpecSection >= 0,
            PricePer: props.model.PricePer == "" ? "Head" : props.model.PricePer,
            SellingPrice: props.model.SellingPrice,
            PricePerHead: props.model.PricePerHead,
            PriceDescription: props.model.PriceDescription,
            Slide: props.model.Slide,
            SlidePrice: props.model.SlidePrice,
            SlideUpDown: props.model.SlideUpDown,
            CurrencyCodeSelected: props.model.CurrencyCodeSelected,
            CurrencyCodeList: props.model.CurrencyCodeList,
            QueryString: props.parentState.QueryString,
            Translations: props.livestockViewModel.Translations,
            HighlightErrors: {},
            FormErrors: props.parentState.SpecsViewModel.FormErrors,
            InputErrors: {}
        };
    }

    componentWillReceiveProps(Props) {

        var errors = this.state;
        var specErrors = Props.SpecsViewModel;
        if (specErrors.HighlightErrors != null && specErrors.HighlightErrors["AverageWeight"]) {
            errors.HighlightErrors.AverageWeight = true;
        }
        else {
            delete errors.HighlightErrors["AverageWeight"];
        }
        if (specErrors.InputErrors != null && specErrors.InputErrors["AverageWeight"] != null) {
            errors.InputErrors.AverageWeight = specErrors.InputErrors["AverageWeight"];
        }
        else {
            delete errors.InputErrors["AverageWeight"];
        }

        Props.SpecsViewModel.FormErrors = Props.parentState.SpecsViewModel.FormErrors;

        let tempPricePer = errors.PricePer;
        if (tempPricePer != this.getCurrentQuantityLabel()) {
            tempPricePer = this.getCurrentQuantityLabel();
            errors.PricePer = tempPricePer;
            this.SaveToXML(errors);
        }

        this.setState({
            PricePer: tempPricePer,
            SpecsViewModel: Props.SpecsViewModel,
            bHasGeneralSpecs: Props.SpecsViewModel.IndexGeneralNotShownInSpecSection >= 0,
            HighlightErrors: errors.HighlightErrors,
            InputErrors: errors.InputErrors,
            FormErrors: Props.parentState.SpecsViewModel.FormErrors,
        });
    }

    getCurrentQuantityLabel() {
        let tempPricePer = "";
        let classCatId = parseInt(this.props.livestockViewModel.ClassCategoryID);
        let EmbryoCats = [171285, 171286, 171287, 171288, 171289, 171290,
            171291, 171292, 171293, 171294, 171295, 171296,
            171297, 171298, 171299, 171300];
        let SemenCats = [171009, 171022, 171035, 171047, 171059, 171065,
            171156, 171165, 171175, 171187, 171199, 171211,
            171223, 171235, 171247, 171079];

        if (EmbryoCats.includes(classCatId)) {
            tempPricePer = "Embryo";
        }
        else if (SemenCats.includes(classCatId)) {
            tempPricePer = "Unit";
        }
        else if (this.state.PricePer == "CWT" || this.state.PricePer == "Pound") {
            tempPricePer = this.state.PricePer;
        }
        else {
            tempPricePer = "Head";
        }
        return tempPricePer
    }

    handleFieldChanged(field, value) {
        var state = this.state;

        //for spec field, we need a special way to update the react state, will be handled in the SpecField case
        var specField = "";
        if (field.indexOf('|') > 0) {
            var fields = field.split("|");
            field = fields[0];
            specField = fields[1];
        }
        else {
            state[field] = value
            delete state.HighlightErrors[field];
            delete state.InputErrors[field];
        }

        switch (field) {
            case "HeadCount":
                if (state.bHasGeneralSpecs && state.SpecsViewModel.FormInputs["AverageWeight"] != null) {
                    state.SpecsViewModel.FormInputs["TotalWeight"].Value = (state.HeadCount * state.SpecsViewModel.FormInputs["AverageWeight"].Value).toFixed(2);
                }
                if (state.PricePer == "Head" || state.PricePer == "Embryo" || state.PricePer == "Unit")
                    state.PricePerHead = state.SellingPrice;
                break;
            case "PricePer":
                if ((value == "CWT" || value == "Pound") && state.bHasGeneralSpecs && state.SpecsViewModel.FormInputs["AverageWeight"].Value == 0) {
                    state.HighlightErrors.AverageWeight = true;
                    state.InputErrors.AverageWeight = "Average Weight Is Required";
                }
                else {
                    delete state.HighlightErrors["AverageWeight"];
                    delete state.InputErrors["AverageWeight"];
                    if (state.SpecsViewModel.FormInputs["WeightStop"] != null) {
                        state.SpecsViewModel.FormInputs["WeightStop"].Value = "";
                        this.props.SaveSpecsToXML(state.SpecsViewModel);
                    }
                    state.SlideUpDown = "";
                    state.SlidePrice = "";
                    state.Slide = "";
                    delete state.HighlightErrors["WeightStop"];
                    delete state.InputErrors["WeightStop"];
                    if (state.PricePer == "CWT" && state.bHasGeneralSpecs && state.SpecsViewModel.FormInputs["AverageWeight"].Value > 0) {
                        state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value / 100) * state.SellingPrice).toFixed(2);
                    } else if (state.PricePer == "Head" || state.PricePer == "Embryo" || state.PricePer == "Unit") {
                        state.PricePerHead = state.SellingPrice;
                    }
                    else if (state.PricePer == "Pound" && state.bHasGeneralSpecs && state.SpecsViewModel.FormInputs["AverageWeight"].Value > 0) {
                        state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value) * state.SellingPrice).toFixed(2);
                    }
                }
                this.SaveToXML(state);
                break;
            case "SellingPrice":
                if (state.PricePer == "Head" || state.PricePer == "Embryo" || state.PricePer == "Unit")
                    state.PricePerHead = state.SellingPrice;
                else if (state.PricePer == "CWT" && state.bHasGeneralSpecs)
                    state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value / 100) * state.SellingPrice).toFixed(2);
                else if (state.PricePer == "Pound" && state.bHasGeneralSpecs)
                    state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value) * state.SellingPrice).toFixed(2);
                break;
            case "PriceDescription":
                break;
            case "CurrencyCodeSelected":
                this.UpdateParentState(state);
                this.SaveToXML(state);
                break;
            case "SpecField":
                //SpecField|HeadCountDateSelected
                if (specField.indexOf('DateSelected') >= 0) {
                    specField = specField.split("DateSelected")[0];
                }
                state.SpecsViewModel.FormInputs[specField].Value = value;
                switch (specField) {
                    case "AverageWeight":
                        state.SpecsViewModel.FormInputs["TotalWeight"].Value = (state.HeadCount * state.SpecsViewModel.FormInputs["AverageWeight"].Value).toFixed(2);
                        if (state.PricePer == "CWT") {
                            state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value / 100) * state.SellingPrice).toFixed(2);
                        }
                        else if (state.PricePer == "Pound") {
                            state.PricePerHead = ((state.SpecsViewModel.FormInputs["AverageWeight"].Value) * state.SellingPrice).toFixed(2);
                        }
                        break;
                    case "EstimatedWeightVariance":
                        this.props.SaveSpecsToXML(state.SpecsViewModel);
                        break;
                }
                break;
            case "Slide":
                if (value == "No") {
                    if (state.SpecsViewModel.FormInputs["WeightStop"] != null) {
                        state.SpecsViewModel.FormInputs["WeightStop"].Value = "";
                        delete state.HighlightErrors["WeightStop"];
                        delete state.InputErrors["WeightStop"];
                    }
                    state.SlideUpDown = "";
                    state.SlidePrice = "";
                }
                break;
            default:
                this.SaveToXML(state);
                break;
        }
        this.setState(state)
    }

    handleOnBlur(sSpecField, spec, e) {
        var state = this.state;

        if (sSpecField == "SpecField") {
            state.SpecsViewModel.QueryString = this.state.QueryString;
            state.SpecsViewModel.FormErrors = this.state.FormErrors;
            //these make sure that any spec errors already present are kept after validation
            if (state.SpecsViewModel.HighlightErrors != null) state.HighlightErrors = state.SpecsViewModel.HighlightErrors;
            if (state.SpecsViewModel.InputErrors != null) state.InputErrors = state.SpecsViewModel.InputErrors;

            this.props.ValidateSpec(spec, state.SpecsViewModel, (validationObject) => {

                if (validationObject.highlightErrors[spec.SpecField] ||
                    validationObject.highlightErrors[spec.SpecField + "unit#"] ||
                    validationObject.highlightErrors[spec.SpecField + "inch#"]) {

                    state.HighlightErrors[spec.SpecField] = validationObject.highlightErrors[spec.SpecField];
                    state.InputErrors[spec.SpecField] = validationObject.inputErrors[spec.SpecField];
                    state.HighlightErrors[spec.SpecField + "unit#"] = validationObject.highlightErrors[spec.SpecField + "unit#"];
                    state.InputErrors[spec.SpecField + "unit#"] = validationObject.inputErrors[spec.SpecField + "unit#"];
                    state.HighlightErrors[spec.SpecField + "inch#"] = validationObject.highlightErrors[spec.SpecField + "inch#"];
                    state.InputErrors[spec.SpecField + "inch#"] = validationObject.inputErrors[spec.SpecField + "inch#"];

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors
                    });
                }
                else {
                    delete state.HighlightErrors[spec.SpecField];
                    delete state.InputErrors[spec.SpecField];
                    delete state.HighlightErrors[spec.SpecField + "unit#"];
                    delete state.InputErrors[spec.SpecField + "unit#"];
                    delete state.HighlightErrors[spec.SpecField + "inch#"];
                    delete state.InputErrors[spec.SpecField + "inch#"];

                    var bNoErrors = Object.keys(state.InputErrors).length == 0;
                    if (bNoErrors) {
                        state.FormErrors = [];
                    }

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors,
                    });

                    var parentState = this.props.parentState;
                    parentState.SpecsViewModel.HighlightErrors = state.HighlightErrors;
                    parentState.SpecsViewModel.InputErrors = state.InputErrors;
                    parentState.SpecsViewModel.FormErrors = state.FormErrors;
                    this.props.handleFormUpdate(parentState);

                    //save xml
                    this.props.SaveSpecsToXML(state.SpecsViewModel);
                }
            });
        }
        else {
            this.SaveToXML(state);
        }
    }

    validatorLivestockPriceInfo() {
        var state = this.state;
        var bHasErrors = false;
        var elementToScrollTo = {};
        var bIsFirstError = true;

        if ((state.PricePer == "CWT" || state.PricePer == "Pound") && state.bHasGeneralSpecs && state.SpecsViewModel.FormInputs["AverageWeight"].Value == 0) {
            state.HighlightErrors.AverageWeight = true;
            state.InputErrors.AverageWeight = "Average Weight Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#AverageWeight');
            }
        }
        else {
            delete state.HighlightErrors["AverageWeight"];
            delete state.InputErrors["AverageWeight"];
        }

        if (state.HeadCount == 0) {
            state.HighlightErrors.HeadCount = true;
            state.InputErrors.HeadCount = "Head Count Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#HeadCount');
            }
        }
        else {
            delete state.HighlightErrors["HeadCount"];
            delete state.InputErrors["HeadCount"];
        }

        if (state.HighlightErrors == null) {
            bHasErrors = false;
        }

        if (bHasErrors) {
            this.setState(state);
            ScrollToElement(elementToScrollTo);
        }

        return bHasErrors;
    }

    SaveToXML(state) {
        var PriceInfoLivestockViewModel = {
            HeadCount: state.HeadCount,
            PricePer: state.PricePer,
            SellingPrice: state.SellingPrice,
            PricePerHead: state.PricePerHead,
            PriceDescription: state.PriceDescription,
            Slide: state.Slide,
            SlidePrice: state.SlidePrice,
            SlideUpDown: state.SlideUpDown,
            CurrencyCodeSelected: state.CurrencyCodeSelected,
        }

        if (state.PricePer == "Head" || state.PricePer == "Embryo" || state.PricePer == "Unit" ) {
            PriceInfoLivestockViewModel.Slide = "";
            PriceInfoLivestockViewModel.SlidePrice = "";
            PriceInfoLivestockViewModel.SlideUpDown = "";
        }

        var objectToSend = this.props.parentState.LivestockViewModel;
        objectToSend.PriceInfoLivestockViewModel = PriceInfoLivestockViewModel;

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/details/saveLivestockDetails' + state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    UpdateParentState(state) {
        var parentState = this.props.parentState;
        var parentStatePriceInfo = this.props.parentState.LivestockViewModel.PriceInfoLivestockViewModel;

        parentStatePriceInfo.HeadCount = state.HeadCount;
        parentStatePriceInfo.PricePer = state.PricePer;
        parentStatePriceInfo.SellingPrice = state.SellingPrice;
        parentStatePriceInfo.PricePerHead = state.PricePerHead;
        parentStatePriceInfo.PriceDescription = state.PriceDescription;
        parentStatePriceInfo.Slide = state.Slide;
        parentStatePriceInfo.SlidePrice = state.SlidePrice;
        parentStatePriceInfo.SlideUpDown = state.SlideUpDown;
        parentStatePriceInfo.CurrencyCodeSelected = state.CurrencyCodeSelected;

        parentState.LivestockViewModel.PriceInfoLivestockViewModel = parentStatePriceInfo;

        this.props.handleFormUpdate(parentState);
    }

    render() {

        var key = 0;

        var animalddl = [];
        animalddl.push({ text: "Select One", value: 0 })
        animalddl.push({ text: "Cattle", value: 1 })
        animalddl.push({ text: "Equine", value: 2 })
        animalddl.push({ text: "Sheep", value: 3 })
        animalddl.push({ text: "Swine", value: 4 })

        var estimatedWeightVarianceddl = [];
        estimatedWeightVarianceddl.push({ text: "Even", value: "Even" })
        estimatedWeightVarianceddl.push({ text: "Uneven", value: "Uneven" })

        var catid = parseInt(this.props.livestockViewModel.AnimalCategoryID);
        var pricePerddl = [];
        pricePerddl.push({ text: "", value: "" })
        pricePerddl.push({ text: "Head", value: "Head" })
        var bIsEmbryoClass = false;
        var bIsSemenClass = false;

        if (this.state.PricePer == "Embryo") {
            pricePerddl = [];
            pricePerddl.push({ text: "Embryo", value: "Embryo" });
            bIsEmbryoClass = true;
        }
        else if (this.state.PricePer == "Unit") {
            pricePerddl = [];
            pricePerddl.push({ text: "Unit", value: "Unit" });
            bIsSemenClass = true;
        }
        else if (catid != 171076) {
            //equine will not have this option
            pricePerddl.push({ text: "CWT", value: "CWT" })
            pricePerddl.push({ text: "Pound", value: "Pound" })
        }

        var slideddl = [];
        slideddl.push({ text: "", value: "" })
        slideddl.push({ text: "Yes", value: "Yes" })
        slideddl.push({ text: "No", value: "No" })
        var slideSection = [];
        var slideOptions = [];
        if (this.state.PricePer == "CWT" || this.state.PricePer == "Pound") {

            slideOptions.push(
                <div className="column4 left" id="Slidecolumn" key={key}>
                    <SelectField
                        id="Slide"
                        className={"addtl-details-select"}
                        placeholder="Slide"
                        value={this.state.Slide}
                        values={slideddl}
                        onFieldChanged={(e) => { this.handleFieldChanged("Slide", e); }}
                        error={this.state.HighlightErrors.Slide}
                        errorText={this.state.InputErrors.Slide}
                    />
                </div>
            );
            key = key + 1;

            if (this.state.Slide == "Yes") {
                slideOptions.push(
                    <div className="column4 left" id="SlidePricecolumn" key={key}>
                        <TextField
                            type='number'
                            min="0"
                            AddCommas={true}
                            NumbersOnly={true}
                            onBlur={(e) => { this.handleOnBlur("SlidePrice", e); }}
                            id="SlidePrice"
                            isRequired={false}
                            label="Slide Price"
                            value={this.state.SlidePrice == 0 ? "" : this.state.SlidePrice.toString()}
                            onFieldChanged={(e) => { this.handleFieldChanged("SlidePrice", e); }}
                            error={this.state.HighlightErrors.SlidePrice}
                            errorText={this.state.InputErrors.SlidePrice}
                        />
                    </div>
                );
                key = key + 1;

                slideOptions.push(
                    <div className="column4 left" id="SlideUpDowncolumn" key={key}>
                        <SelectField
                            id="SlideUpDown"
                            className={"addtl-details-select"}
                            placeholder="Slide Up Down"
                            value={this.state.SlideUpDown}
                            values={slideddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("SlideUpDown", e); }}
                            error={this.state.HighlightErrors.SlideUpDown}
                            errorText={this.state.InputErrors.SlideUpDown}
                        />
                    </div>
                );
                key = key + 1;
            }
        }

        var generalSpecs = [];
        if (this.state.bHasGeneralSpecs) {
            var specs = this.state.SpecsViewModel.oMMMCategoryGroupSpecs[this.state.SpecsViewModel.IndexGeneralNotShownInSpecSection].Specs;
            for (let i = 0; i < specs.length; i++) {
                let spec = specs[i];
                if (spec.SpecField == "HeadCount" && bIsEmbryoClass) {
                    spec.Label = "Embryo Count";
                }
                else if (spec.SpecField == "HeadCount" && bIsSemenClass) {
                    spec.Label = "Unit Count";
                }
                else if (spec.SpecField == "HeadCount"){
                    spec.Label = "Head Count";
                }

                if (spec.SpecField == "HeadCount"
                    || spec.SpecField == "AverageWeight"
                    || spec.SpecField == "TotalWeight"
                    || spec.SpecField == "EstimatedWeightVariance"
                    || spec.SpecField == "WeightStop") {
                    switch (spec.SpecInputControlType) {
                        case "MultiLineTextBox":
                            generalSpecs.push(
                                <div className="column6 left accordian-skip" key={key} style={{ width: "98%" }}>
                                    <TextField
                                        type="textarea"
                                        feRequired={spec.RecommendedForEvaluation}
                                        onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                        id={spec.SpecField}
                                        label={spec.Label}
                                        value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                        onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                        error={this.state.HighlightErrors[spec.SpecField]}
                                        errorText={this.state.InputErrors[spec.SpecField]}
                                    />
                                </div>
                            );
                            break;
                        case "CheckBox":
                            if (this.state.SpecsViewModel.FormInputs[spec.SpecField].Value == "") {
                                this.state.SpecsViewModel.FormInputs[spec.SpecField].Value = "0";
                            }
                            generalSpecs.push(
                                <div className="column6 left accordian-skip" key={key} style={{ marginTop: "15px" }}>
                                    <TextField
                                        inline={true}
                                        type="checkbox"
                                        YesNo={spec.IsYesNo}
                                        isSpec={true}
                                        feRequired={spec.RecommendedForEvaluation}
                                        id={spec.SpecField}
                                        label={spec.Label}
                                        value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                        onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                        error={this.state.HighlightErrors[spec.SpecField]}
                                        errorText={this.state.InputErrors[spec.SpecField]}
                                    />
                                </div>
                            );
                            break;
                        case "TextBox":
                            let disabled = false
                            if (spec.SpecField == "TotalWeight")
                                disabled = true;

                            if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {

                                let selectID = spec.SpecField + "unit#";

                                var selectvalues = [];

                                for (let a = 0; a < spec.MeasurementUnitOptions.length; a++) {
                                    for (let b = 0; b < this.state.SpecsViewModel.oMMMMeasurementUnit.length; b++) {
                                        if (spec.MeasurementUnitOptions[a] == this.state.SpecsViewModel.oMMMMeasurementUnit[b].MeasurementUnitID) {
                                            selectvalues.push({ text: this.state.SpecsViewModel.oMMMMeasurementUnit[b].Symbol, value: this.state.SpecsViewModel.oMMMMeasurementUnit[b].Unit })
                                            break;
                                        }
                                    }
                                }

                                if (this.state.SpecsViewModel.FormInputs[selectID].Value == "foot") {
                                    let inchfield = spec.SpecField + "inch#";
                                    generalSpecs.push(
                                        <div className="column6 left accordian-skip" key={key}>
                                            <TextField
                                                type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                feRequired={spec.RecommendedForEvaluation}
                                                onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                                AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                id={spec.SpecField}
                                                isRequired={spec.Required}
                                                label={spec.Label}
                                                value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                SmallInput={true}
                                                className={"footSpecText"}
                                                mileageinch={true}
                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                                error={this.state.HighlightErrors[spec.SpecField]}
                                                errorText={this.state.InputErrors[spec.SpecField]}
                                            />
                                            <SelectField
                                                id={selectID}
                                                value={this.state.SpecsViewModel.FormInputs[selectID].Value}
                                                SmallSelect={true}
                                                className={"v-small-select"}
                                                values={selectvalues}
                                                mileageinch={true}
                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + selectID, e); }}
                                                bShowFullName={true}
                                                error={this.state.HighlightErrors[selectID]}
                                                errorText={this.state.InputErrors[selectID]}
                                                hasLabel={true}
                                                ariaLabelledBy={spec.SpecField + "label"}
                                            />
                                            <TextField
                                                type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                feRequired={spec.RecommendedForEvaluation}
                                                onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                                AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                id={inchfield}
                                                SmallInput={true}
                                                className={"inchSpecText"}
                                                isRequired={spec.Required}
                                                value={this.state.SpecsViewModel.FormInputs[inchfield].Value}
                                                mileageinchsecond={true}
                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + inchfield, e); }}
                                                error={this.state.HighlightErrors[inchfield]}
                                                errorText={this.state.InputErrors[inchfield]}
                                            />
                                            <label htmlFor={inchfield}> in.</label>
                                            <div className="validationError">
                                                <span>{this.state.InputErrors[spec.SpecField]}</span>
                                            </div>
                                        </div>
                                    );
                                }
                                else {
                                    generalSpecs.push(
                                        <div className="column6 left accordian-skip" key={key}>
                                            <TextField
                                                type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                feRequired={spec.RecommendedForEvaluation}
                                                AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                id={spec.SpecField}
                                                disabled={disabled}
                                                onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                                isRequired={spec.Required}
                                                SmallInput={true}
                                                label={spec.Label}
                                                value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                mileage={true}
                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                                error={this.state.HighlightErrors[spec.SpecField]}
                                            />
                                            <SelectField
                                                id={selectID}
                                                disabled={disabled}
                                                value={this.state.SpecsViewModel.FormInputs[selectID].Value}
                                                className="addtl-details-small-select"
                                                SmallSelect={true}
                                                values={selectvalues}
                                                mileage={true}
                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + selectID, e); }}
                                                bShowFullName={true}
                                                error={this.state.HighlightErrors[selectID]}
                                                errorText={this.state.InputErrors[selectID]}
                                                hasLabel={true}
                                                ariaLabelledBy={spec.SpecField + "label"}
                                            />
                                            <div className="validationError">
                                                <span>{this.state.InputErrors[spec.SpecField]}</span>
                                            </div>
                                        </div>
                                    );
                                }
                            }
                            else {
                                generalSpecs.push(
                                    <div className="column6 left accordian-skip" key={key}>
                                        <TextField
                                            type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                            min={spec.SpecDataFormat == "Number" ? "0" : null}
                                            feRequired={spec.RecommendedForEvaluation}
                                            AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                            onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                            id={spec.SpecField}
                                            isRequired={spec.Required}
                                            label={spec.Label}
                                            value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                            onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                            error={this.state.HighlightErrors[spec.SpecField]}
                                            errorText={this.state.InputErrors[spec.SpecField]}
                                        />
                                    </div>
                                );
                            }

                            if (spec.SpecField == "WeightStop") {
                                var weightStopSpec = generalSpecs.pop();
                                if (this.state.Slide == "Yes") {
                                    slideOptions.push(weightStopSpec);
                                }
                            }
                            break;
                        case "AutoComplete":
                            if (spec.UsesDynamicSource == true) {
                                if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                    for (var a = 0; a < this.state.oDynamicAutoComplete.length; a++) {
                                        if (this.state.oDynamicAutoComplete[a].DefinedSpecID == spec.DefinedSpecID) {
                                            for (var y = 0; y < this.state.DependentAutoComplete.length; y++) {
                                                if (this.state.DependentAutoComplete[y].SpecField == spec.SpecField) {
                                                    generalSpecs.push(
                                                        <div className="column6 left accordian-skip" key={key}>
                                                            <AutoCompleteField
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                FromList={true}
                                                                onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                                                isRequired={spec.Required}
                                                                disabled={this.state.DependentAutoComplete[y].Disabled}
                                                                id={spec.SpecField}
                                                                label={spec.Label}
                                                                value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                                values={this.state.DependentAutoComplete[y].Source}
                                                                onFieldChanged={(value) => { this.handleFieldChanged("SpecField|" + spec.SpecField, value); }}
                                                                error={this.state.HighlightErrors[spec.SpecField]}
                                                                errorText={this.state.InputErrors[spec.SpecField]}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    for (var a = 0; a < this.state.oDynamicAutoComplete.length; a++) {
                                        if (this.state.oDynamicAutoComplete[a].DefinedSpecID == spec.DefinedSpecID) {
                                            generalSpecs.push(
                                                <div className="column6 left accordian-skip" key={key}>
                                                    <AutoCompleteField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        FromList={true}
                                                        id={spec.SpecField}
                                                        onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                                        isRequired={spec.Required}
                                                        label={spec.Label}
                                                        value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                        values={this.state.oDynamicAutoComplete[a].Source}
                                                        onFieldChanged={(value) => { this.handleFieldChanged("SpecField|" + spec.SpecField, value); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                        }
                                    }
                                }
                            }
                            else {
                                var autocompletes = [];
                                for (var b = 0; b < spec.InputControlListOptions.length; b++) {
                                    autocompletes.push(spec.InputControlListOptions[b].Text);
                                }
                                generalSpecs.push(
                                    <div className="column6 left accordian-skip" key={key}>
                                        <AutoCompleteField
                                            feRequired={spec.RecommendedForEvaluation}
                                            isRequired={spec.Required}
                                            onBlur={(e) => { this.handleOnBlur("SpecField", spec, e); }}
                                            id={spec.SpecField}
                                            label={spec.Label}
                                            value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                            values={autocompletes}
                                            onFieldChanged={(value) => { this.handleFieldChanged("SpecField|" + spec.SpecField, value); }}
                                            error={this.state.HighlightErrors[spec.SpecField]}
                                            errorText={this.state.InputErrors[spec.SpecField]}
                                        />
                                    </div>
                                );
                            }
                            break;
                        case "RadioButtonList":
                            let radios = [];
                            for (var c = 0; c < spec.InputControlListOptions.length; c++) {
                                radios.push({ text: spec.InputControlListOptions[c].Text, value: spec.InputControlListOptions[c].Value })
                            }

                            generalSpecs.push(<div className="label" key={spec.Label + "_label"} htmlFor={spec.SpecField}>{spec.Label}{spec.Required ? <span>*</span> : ""}</div>);
                            generalSpecs.push(
                                <div className="column6 left accordian-skip" key={key}>
                                    <RadioField
                                        feRequired={spec.RecommendedForEvaluation}
                                        id={spec.SpecField}
                                        radios={radios}
                                        value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                        isvertical={false}
                                        onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                        error={this.state.HighlightErrors[spec.SpecField]}
                                        errorText={this.state.InputErrors[spec.SpecField]}
                                        label={spec.Label}
                                    />
                                </div>
                            );
                            break;
                        case "DropDownList":
                            if (spec.UsesDynamicSource == true) {
                                if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                    for (var a = 0; a < this.state.oDynamicDropDown.length; a++) {
                                        if (this.state.oDynamicDropDown[a].DefinedSpecID == spec.DefinedSpecID) {
                                            for (var y = 0; y < this.state.DependentDropDowns.length; y++) {
                                                if (this.state.DependentDropDowns[y].SpecField == spec.SpecField) {
                                                    generalSpecs.push(
                                                        <div className="column6 left accordian-skip" key={key}>
                                                            <SelectField
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                isRequired={spec.Required}
                                                                disabled={this.state.DependentDropDowns[y].Disabled}
                                                                id={spec.SpecField}
                                                                className={"spec-select"}
                                                                placeholder={spec.Label}
                                                                value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                                values={this.state.DependentDropDowns[y].DropDownOptions}
                                                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                                                bShowFullName={true}
                                                                error={this.state.HighlightErrors[spec.SpecField]}
                                                                errorText={this.state.InputErrors[spec.SpecField]}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    for (var a = 0; a < this.state.oDynamicDropDown.length; a++) {
                                        if (this.state.oDynamicDropDown[a].DefinedSpecID == spec.DefinedSpecID) {
                                            generalSpecs.push(
                                                <div className="column6 left accordian-skip" key={key}>
                                                    <SelectField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        isRequired={spec.Required}
                                                        id={spec.SpecField}
                                                        className={"spec-select"}
                                                        placeholder={spec.Label}
                                                        value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                                        values={this.state.DependentDropDowns[y].DropDownOptions}
                                                        onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                        }
                                    }
                                }
                            }
                            else {
                                let options = [];
                                for (var b = 0; b < spec.InputControlListOptions.length; b++) {
                                    options.push({ text: spec.InputControlListOptions[b].Text, value: spec.InputControlListOptions[b].Value });
                                }

                                generalSpecs.push(
                                    <div className="column6 left accordian-skip" key={key}>
                                        <SelectField
                                            feRequired={spec.RecommendedForEvaluation}
                                            isRequired={spec.Required}
                                            id={spec.SpecField}
                                            className={"addtl-details-select"}
                                            placeholder={spec.Label}
                                            value={this.state.SpecsViewModel.FormInputs[spec.SpecField].Value}
                                            values={options}
                                            onFieldChanged={(e) => { this.handleFieldChanged("SpecField|" + spec.SpecField, e); }}
                                            bShowFullName={true}
                                            error={this.state.HighlightErrors[spec.SpecField]}
                                            errorText={this.state.InputErrors[spec.SpecField]}
                                        />
                                    </div>
                                );
                            }
                            break;
                    }
                }
                key = key + 1;
            }
        }

        if (this.state.PricePer == "CWT" || this.state.PricePer == "Pound") {
            slideSection.push(
                <div key={key}>
                    {slideOptions}
                </div>
            );
            key = key + 1;
        }

        let currencyddl = [];
        for (let i = 0; i < this.state.CurrencyCodeList.length; i++) {
            currencyddl.push({ text: this.state.CurrencyCodeList[i], value: this.state.CurrencyCodeList[i] })
        };

        let CountLabel = bIsEmbryoClass ? "Embryo Count" : (bIsSemenClass ? "Unit Count" : "Head Count");
        let PricePerLabel = bIsEmbryoClass ? "Price Per Embryo" : (bIsSemenClass ? "Price Per Unit" : "Price Per Head");

        return (
            <div>
                {/*Header for Price Info*/}
                <div className="additional-details" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { PriceOptionsToggle(e); } }} onClick={(e) => { PriceOptionsToggle(e) }} tabIndex="0">
                    <div className="price-options" style={{ display: 'none' }}>
                        <strong>Pricing Information Details <i className="fa fa-plus" aria-hidden="true"></i></strong>
                    </div>
                    <div className="price-options-2">
                        <strong>Close Pricing Information Details <i className="fa fa-minus" aria-hidden="true"></i></strong>
                    </div>
                </div>

                {/*Content to be toggled*/}
                <div className="price-content" style={{ display: 'block' }}>

                    {/*General Section*/}
                    <div className="expand">
                        <button role="link" className="spec-group-label priceInfo-group-label expanded" id="priceDetails-groupName-0" onClick={(e) => { TogglePriceInfoSubSections(0) }}>General</button>
                    </div>
                    <div className="accordion cf" id="priceDetails-content-0" style={{ display: 'block' }}>
                        <div className="validationError">
                            <span>{this.state.FormErrors}</span>
                        </div>

                        {/*Head Count*/}
                        <div className="column6 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                NumbersOnly={true}
                                AddCommas={true}
                                onBlur={(e) => { this.handleOnBlur("HeadCount", e); }}
                                id="HeadCount"
                                isRequired={false}
                                label={CountLabel}
                                value={this.state.HeadCount == 0 ? "" : this.state.HeadCount.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("HeadCount", e); }}
                                error={this.state.HighlightErrors.HeadCount}
                                errorText={this.state.InputErrors.HeadCount}
                            />
                        </div>

                        {generalSpecs}
                    </div>

                    {/*Pricing Information Section*/}
                    <div className="expand">
                        <button role="link" className="spec-group-label priceInfo-group-label expanded" id="priceDetails-groupName-1" onClick={(e) => { TogglePriceInfoSubSections(1) }}>Pricing Information</button>
                    </div>
                    <div className="accordion cf" id="priceDetails-content-1" style={{ display: 'block' }}>
                        <div className="validationError">
                            <span>{this.state.FormErrors}</span>
                        </div>
                        <div className="column4 left accordian-skip">
                            <SelectField
                                id="PricePer"
                                className={"addtl-details-select"}
                                placeholder="Price Per"
                                value={this.state.PricePer}
                                values={pricePerddl}
                                onFieldChanged={(e) => { this.handleFieldChanged("PricePer", e); }}
                                error={this.state.HighlightErrors.PricePer}
                                errorText={this.state.InputErrors.PricePer}
                            />
                        </div>
                        <div className="column4 left accordian-skip">
                            <div style={{ width: '46%', display: 'inline-block', paddingRight: '7px' }}>
                                <TextField
                                    type='number'
                                    min="0"
                                    AddCommas={true}
                                    NumbersOnly={true}
                                    onBlur={(e) => { this.handleOnBlur("SellingPrice", e); }}
                                    id="SellingPrice"
                                    isRequired={false}
                                    label="Selling Price"
                                    value={this.state.SellingPrice == 0 ? "" : this.state.SellingPrice.toString()}
                                    onFieldChanged={(e) => { this.handleFieldChanged("SellingPrice", e); }}
                                    error={this.state.HighlightErrors.SellingPrice}
                                    errorText={this.state.InputErrors.SellingPrice}
                                />
                            </div>
                            <div style={{ width: '45%', display: 'inline-block' }}>
                                <SelectField
                                    id="CurrencyCodeSelected"
                                    value={this.state.CurrencyCodeSelected}
                                    className="currency-priceInformation-ddl"
                                    SmallSelect={true}
                                    values={currencyddl}
                                    onFieldChanged={(e) => { this.handleFieldChanged("CurrencyCodeSelected", e); }}
                                    error={this.state.HighlightErrors.CurrencyCodeSelected}
                                    errorText={this.state.InputErrors.CurrencyCodeSelected}
                                    hasLabel={true}
                                    ariaLabelledBy={"SellingPricelabel"}
                                />
                            </div>
                        </div>
                        <div className="column4 left accordian-skip">
                            <TextField
                                type='number'
                                min="0"
                                AddCommas={true}
                                NumbersOnly={true}
                                onBlur={(e) => { this.handleOnBlur("PricePerHead", e); }}
                                disabled={true}
                                id="PricePerHead"
                                isRequired={false}
                                label={ PricePerLabel }
                                value={this.state.PricePerHead == 0 ? "" : this.state.PricePerHead.toString()}
                                onFieldChanged={(e) => { this.handleFieldChanged("PricePerHead", e); }}
                                error={this.state.HighlightErrors.PricePerHead}
                                errorText={this.state.InputErrors.PricePerHead}
                            />
                        </div>

                        {/*Only shows if Price Per is CWT or by Pound*/}
                        {slideSection}

                        <div className="column12 left">
                            <TextField
                                id="PriceDescription"
                                type={"textarea"}
                                label="Price Description"
                                value={this.state.PriceDescription}
                                onFieldChanged={(e) => { this.handleFieldChanged("PriceDescription", e); }}
                                onBlur={(e) => { this.handleOnBlur("PriceDescription"); }}
                                characterLimit={50000}
                                error={this.state.HighlightErrors.PriceDescription}
                                errorText={this.state.InputErrors.PriceDescription}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PriceInfoLivestockForm;
global.PriceInfoLivestockForm = PriceInfoLivestockForm;